import * as moment from 'moment'
import * as _ from 'lodash'
import { IPenalty } from '../Model/Questionnaire'
import Payment, { PaymentStatus, PaymentType } from '../Model/Payment'
import { PaymentScheduleItemModel } from '../Model/PaymentScheduleItemModel'

export function getAlreadyNeedPaidSum(scheduleArr: Array<PaymentScheduleItemModel>, prepaymentSum: number): number {
    if (!scheduleArr || !scheduleArr.length) {
        return 0
    }

    let alreadySumMustBePaid = _.sumBy(
        scheduleArr.filter(x => {
            return moment().isAfter(x.date)
        }),
        'sum'
    ) + prepaymentSum

    return alreadySumMustBePaid
}

export function getPaymentSchedule(paymentsSchedule: object): Array<PaymentScheduleItemModel> {
    let scheduleArr = []
    for (let key in paymentsSchedule) {
        if (paymentsSchedule.hasOwnProperty(key)) {
            scheduleArr.push(
                new PaymentScheduleItemModel(
                    moment(key).toDate(),
                    paymentsSchedule[key]
                )
            )
        }
    }

    return scheduleArr
}

export function getPaymentScheduleSum(scheduleArr: Array<PaymentScheduleItemModel>): number {
    if (!scheduleArr || !scheduleArr.length) {
        return 0
    }
    return _.sum(scheduleArr.map(x => x.sum))
}

export function getCurrentDebtByCreditBody(
    balance: number,
    scheduleArr: Array<PaymentScheduleItemModel>,
    prepaymentSum: number) {
    if (!scheduleArr || !scheduleArr.length) {
        return 0
    }

    let creditBodySum = getCreditBodySum(scheduleArr, prepaymentSum)
    return _.round(
        creditBodySum -
        balance,
        2)
}

export function getCurrentDebt(
    balance: number,
    scheduleArr: Array<PaymentScheduleItemModel>,
    prepaymentSum: number,
    penalty: number) {
    if (!scheduleArr || !scheduleArr.length) {
        return 0
    }

    let alreadySumMustBePaid = getAlreadyNeedPaidSum(scheduleArr, prepaymentSum)
    return _.round(
        alreadySumMustBePaid +
        penalty -
        balance,
        2)
}

export function getPenalty(penalty: number) {
    return _.round(penalty, 2)
}

export function getLastPenaltyAmountFromList(penalties: Array<IPenalty>): number {
    if (!penalties || !penalties.length) {
        return 0
    }

    return penalties[penalties.length - 1]!.amount
}

export function getCreditBodySum(
    scheduleArr: Array<PaymentScheduleItemModel>,
    prepaymentSum: number): number {
    if (!scheduleArr || !scheduleArr.length) {
        return 0
    }

    return _.round(getPaymentScheduleSum(scheduleArr) + prepaymentSum, 2)
}

export function getPaymentPerMonth(scheduleArr: Array<PaymentScheduleItemModel>) {
    if (!scheduleArr || !scheduleArr.length) {
        return 0
    }
    return _.round(_.orderBy(scheduleArr, x => x.date, 'desc')[0].sum, 2)
}

export function getPaymentsSum(payments: Array<Payment>): number {
    if (!payments || !payments.length) {
        return 0
    }

    return _.round(
        _.sumBy(
            payments
                .filter(x => x.paymentStatus === PaymentStatus.Done),
            x => x.amount),
        2)
}

export function getFeeSum(payments: Array<Payment>): number {
    return getPaymentsSum(payments
        .filter(x => x.paymentType === PaymentType.Fee));
}

export function getPenaltiesSum(payments: Array<Payment>): number {
    return getPaymentsSum(payments.filter(x => x.paymentType === PaymentType.Penalty))
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/PaymentScheduleHelper.ts